const MINUTES_PER_EXERCISE = 30

export const calcDurationMinutes = (exerciseCount: number): number =>
  exerciseCount * MINUTES_PER_EXERCISE

export const formatDuration = (minutes: number): string => {
  if (minutes <= 0) return '—'
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return `${m}m`
  if (m === 0) return `${h}h`
  return `${h}h ${m}m`
}
